const CHANNELS = [
  {
    icon: "bi-envelope-fill",
    sideClass: "bg-[#E8F0FE] text-[#2B6CB0]",
    title: "Email consent tracking",
    text: "Capture opt-in / opt-out from email journeys, double opt-in links and reply-based confirmations. Every event is logged against the Data Principal and purpose.",
    tags: ["Double opt-in", "Unsubscribe sync", "Message proof", "Purpose tags"],
  },
  {
    icon: "bi-whatsapp",
    sideClass: "bg-[#E6F6EC] text-[#15803D]",
    title: "WhatsApp consent tracking",
    text: "Record consent obtained via WhatsApp Business flows and templates — ideal for India-first engagement where messaging is the default channel.",
    tags: ["Template messages", "Keyword opt-in", "Chat artefact", "Withdrawal"],
  },
];

export default function Channels() {
  return (
    <section id="channels" className="py-20 bg-white border-b border-line">
      <div className="container mx-auto max-w-[1140px] px-4">
        <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
          Omnichannel capture
        </p>
        <h2 className="font-bricolage text-[clamp(1.75rem,3vw,2.3rem)] mb-[0.7rem] text-ink">
          Track consent on Email and WhatsApp
        </h2>
        <p className="text-[1.05rem] leading-[1.65] text-slate max-w-[40rem]">
          Consent does not only happen on web forms. OneDPDP records and
          proves consent collected over Email and WhatsApp — with
          timestamps, purpose, language and proof artefacts.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-11">
          {CHANNELS.map((c) => (
            <div key={c.title} className="rounded-xl border border-line overflow-hidden bg-surface grid grid-cols-[auto_1fr] sm:grid-cols-[88px_1fr]">
              <div className={`w-[72px] sm:w-[88px] flex items-center justify-center text-[2rem] ${c.sideClass}`}>
                <i className={`bi ${c.icon}`} />
              </div>
              <div className="p-[1.6rem_1.5rem]">
                <h3 className="text-[1.2rem] font-bricolage font-semibold mb-[0.45rem]">{c.title}</h3>
                <p className="m-0 text-slate text-[0.95rem] leading-[1.55]">{c.text}</p>
                <div className="flex flex-wrap gap-[0.45rem] mt-4">
                  {c.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-[0.72rem] font-semibold px-[0.55rem] py-[0.28rem] rounded bg-white border border-line text-slate-2"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
